export const selectActiveThreadId = state => state.chatv2.threadId;
export const selectIsCurrentThreadAutocreated = state => state.chatv2.isCurrentThreadAutocreated;
export const selectIsCreatingThread = state => state.chatv2.isCreatingThread;
export const selectMessages = state => state.chatv2.messages;
export const selectMessageCount = state => state.chatv2.messages.length;
export const selectDraftChatMessage = state => state.chatv2.draftChatMessage;
export const selectFetchStatus = state => state.chatv2.fetchStatus;
export const selectIsWaitingForResponse = state => state.chatv2.isWaitingForResponse;
export const selectHasMore = state => state.chatv2.hasMore;
export const selectOffset = state => state.chatv2.offset;
export const selectPagingStatus = state => state.chatv2.pagingStatus;
export const selectAblyChannelId = state => state.chatv2.ablyChannelId;
export const selectAblyChannelConnectingState = state => state.chatv2.ablyChannelConnectingState;
export const selectStreamingCurrentToolCall = state => state.chatv2.streaming.currentToolCall;
export const selectStreamingInteractionId = state => state.chatv2.streaming.interactionId;
export const selectShowCsatSurvey = state => state.chatv2.showCsatSurvey;
export const selectShouldPollCsatSurvey = state => state.chatv2.shouldPollCsatSurvey;
export const selectIsSavedPrompt = state => state.chatv2.isSavedPrompt;
export const selectIsReadOnly = state => state.chatv2.isReadOnly;
export const selectFailedUserMessages = state => state.chatv2.failedUserMessages;
export const selectInteractionDurations = state => state.chatv2.interactionDurations;
export const selectAppSearchScope = state => state.chatv2.appSearchScope;
export const selectConnectedApps = state => state.chatv2.appsControl.connectedApps;
export const selectNewAvailableApps = state => state.chatv2.appsControl.newAvailableApps;
export const selectIsInteractiveModeActive = state => state.chatv2.isInteractiveModeActive;